import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import TreatmentHero from './components/TreatmentHero';
import TreatmentGrid from './components/TreatmentGrid';
import ProcessSection from './components/ProcessSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';

const Treatments: React.FC = () => {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <main>
        <TreatmentHero />
        <TreatmentGrid />
        <ProcessSection />
        <TestimonialsSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default Treatments;